import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() inline:any;
  @Input() small:any;
  longWait = false;

  ngOnInit() {
    setTimeout((count:number) => {
      this.longWait = true;
    }, 10000);
  }

  refresh(): void {
    window.location.reload();
  }
}
